import { Behavior } from "../../base/Behavior";
import { EditRowDecorator } from "./EditRowDecorator";
import { DataSourceMode } from "../../databinding/DataSource";
import { Label } from "../../components/label/Label";
import { MultiButton } from "../../components/multibutton/MultiButton";

export class EditRowDecoratorBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public addSaveButton(decorator: EditRowDecorator, saveAndAddFunc: Function, saveAndCloseFunc: Function): void {
        if (decorator.onSave != null) {
            const addlActions = [];
            if (DataSourceMode.SEARCH !== decorator.dataSourceMode && decorator.onAddAnother != null)
                addlActions.push(new Label({ text: "Save & Add Another", id: "erdSaveAddAnotherLabel", onClick: () => saveAndAddFunc() }));

            decorator.multiButton = new MultiButton({
                themeKey: "editRowDecorator.multiButton",
                id: "erdMultiButton",
                rowBreak: false,
                dropdownItems: addlActions,
                ...decorator.saveButtonProps
            });

            decorator.multiButton.primaryButton.setProps({
                themeKey: "editRowDecorator.primaryButton",
                id: "erdButtonSaveClose",
                caption: "Save & Close",
                default: true
            });

            decorator.multiButton.primaryButton.addClickListener(() => saveAndCloseFunc());
            decorator.panelHeader.add(decorator.multiButton);
        }
    }

    get type(): string {
        return "EditRowDecorator";
    }
}

EditRowDecoratorBehavior.register();
